import { IClassname } from '@/lib/shared/model/classname';

export const Coworking = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7380)">
        <path
          d="M13.604 21.4312H3.63625C3.25288 21.4312 2.99728 21.1756 2.7417 20.92L1.71938 18.3642C1.59159 18.1086 1.59159 17.7252 1.71938 17.4697C1.84717 17.2141 2.23053 16.9585 2.48612 16.9585H23.9551"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.83096 21.4312L4.01953 30.3766"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.3765 9.41895H30.1209C29.482 9.41895 28.9708 9.93011 28.843 10.5691L27.3095 21.4314C27.1817 22.0703 26.6706 22.5815 26.0316 22.5815H18.2363L16.1917 24.6262"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.4919 30.3765H26.7984"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6454 13.1248H6.14417C5.12184 13.1248 4.22729 12.2302 4.22729 11.2079V3.54041C4.22729 2.51808 5.12184 1.62354 6.14417 1.62354H17.6454C18.6678 1.62354 19.5623 2.51808 19.5623 3.54041V11.2079C19.5623 12.2302 18.6678 13.1248 17.6454 13.1248Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.97789 13.1245L8.95557 16.9583"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8118 13.1245L14.7063 16.9583"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.6453 22.5894V30.3767"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7380">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
